<template>
    <section class="administration-companies">
        <!-- Companies-->
        <group-companies @open="openModal" />

        <hr />

        <!-- Company info-->
        <div class="company-info" v-if="(companiesSelected && companiesSelected.length > 0)">
            <div class="section-header">Valgte virksomhed</div>
            <div class="grid-x list-row align-items" v-for="company in selectedCompanies" @click="openModal('administration-modal-company', company)" :key="company.id">
                <div class="flexbox-center">
                    <icon class="medium-svg fill-dark-gray" name="building" />
                </div>
                <div class="cell small-3 item flexbox-align-items">
                    <span class="truncate-ellipse">{{ company.name }}</span>
                </div>
                <div class="cell small-4 item">
                    <span class="truncate-ellipse">{{ company.email }}</span>
                    <span class="truncate-ellipse">{{ company.phoneNumber }}</span>
                </div>
                <div class="cell small-3 item">
                    <span v-if="company.address1" class="truncate-ellipse">{{ company.address1 }}</span>
                    <span v-else class="truncate-ellipse">Ingen adresse</span>
                </div>
            </div>
        </div>

        <hr />

        <!-- Employee-->
        <list-company-employee @open="openModal" />
    </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import employeeCompanyList from './../../shared/list/list-company-employee.vue'
import companiesGroup from './administration-companies-group.vue'

export default {
    components: {
        'list-company-employee': employeeCompanyList,
        'group-companies': companiesGroup
    },
    data () {
        return {
            view: null
        }
    },
    computed: {
        ...mapGetters({
            companies: 'getAllOrganizationList',
            companiesSelected: 'getSelectedCompanies'
        }),
        selectedCompanies () {
            if (this.companiesSelected.length > 0) {
                let selectedCompany = this.companies.filter(company => company.id === this.companiesSelected[0].id)
                if (selectedCompany.length > 0) {
                    return selectedCompany
                }
            }
        }
    },
    methods: {
        ...mapActions({
            setCompany: 'setCompany'
        }),
        openModal (view, company) {
            new Promise((resolve, reject) => {
                resolve(this.setCompany(company))
            }).then(() => {
                this.$emit('open', view)
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/administration/administration-companies.vue